import { render } from "./navigation_entry.vue?vue&type=template&id=de2c2c50"
import script from "./navigation_entry.js?vue&type=script&lang=js"
export * from "./navigation_entry.js?vue&type=script&lang=js"

import "./navigation_entry.vue?vue&type=style&index=0&id=de2c2c50&lang=scss"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__